// @ts-nocheck

import React from 'react';
import { Group, Text, Rect } from 'react-konva';

import { __ } from '../../../i18n/l10n';
import { getRelativeValue } from '../utils';

const BankerBadge = (props) => {
  const { height, stageWidth } = props;

  return (
    <Group x={getRelativeValue(360, stageWidth)} y={0}>
      <Rect
        x={0}
        y={0}
        width={getRelativeValue(40, stageWidth)}
        height={height}
        fill="#f1f1f1"
        cornerRadius={[0, 0, 0, 15]}
      />
      <Text
        text={__('Base').toUpperCase()}
        x={0}
        y={getRelativeValue(1, stageWidth)}
        width={getRelativeValue(40, stageWidth)}
        height={height}
        align="center"
        verticalAlign="middle"
        fontSize={getRelativeValue(11, stageWidth)}
        fontFamily="BettingPoliticaExtraBold, sans-serif"
        fill="#393838"
        fontStyle={200}
      />
    </Group>
  );
};

export default BankerBadge;
